module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.0.0.box.534.474.645.324.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.16.0.0.box.671.474.374.161.q.101"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center",
      "font-variant": "small-caps",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.16.0.1.box.534.723.645.75.q.90"
    }
  }, [_vm._v("Wilderness Diplomat")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.3.0.box.275.958.1157.1336.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.16.3.0.box.279.958.1153.682.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "GBS.PP15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.0.0"
    }
  }), _vm._v("T")]), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.2.0"
    }
  }), _vm._v("he renommée, fri"), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.0.0.0"
    }
  }), _vm._v("gate of king louis")]), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0"
    }
  }), _vm._v("  navy, floated ghostlike through veils of fog toward the mysterious, broken shore line. The captain, Pierre Le Moyne, Sieur d'Iberville, called a junior officer to his side at starboard. The younger officer was the captain's cousin and uncle-in-law—a man who, like himself, bore a distinguished Canadian name—Louis Juchereau de St. Denis. The captain pointed a bold hand landward: \"Louisiana!\" he announced, with a ring in his voice. This was a magical word to Frenchmen, a will-o'-the-wisp name that had become alluring but not quite real.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.3.1.box.276.1662.1151.338.q.60"
    }
  }, [_vm._v("Without waiting for comment, the captain continued to scan the shore line searching for a point called Deer Island, a name he himself had first written on the maps. Islands of gleaming, green-specked sand, reef-covered bars, and hazy timbered silhouettes on the distant mainland floated by.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.3.2.box.275.2010.1150.217.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.2.0"
    }
  }), _vm._v("Presently a wind-swept, water-beaten island loomed ahead—Deer Island. The ship steered northward around the island. Beyond was a bay, a river, and a lone outpost of colonial France.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.16.3.3.box.326.2244.1096.50.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.3.0"
    }
  }), _vm._v("Anchors dropped. Men rowed ashore. Iberville had re"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.1.0.box.282.412.1154.333.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0"
    }
  }), _vm._v("turned to his colony. And on this seventh day of the year 1700, Iberville's cousin, Louis Juchereau de St. Denis, had found a new country and had been bewitched by it on sight; and the Louisiana colony unknowingly welcomed its strangest and most fabulous promoter and protector.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.17.1.0.box.282.412.1154.333.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.2.0.box.275.824.1159.1509.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.0.box.279.824.1155.567.q.60"
    }
  }, [_vm._v("So overjoyed were the inhabitants of the outpost of Biloxi at seeing the relief ship that \"all the guns and musketry of the fort\" had been fired to salute the vessel. There were good reasons to be hilariously jubilant, for since Iberville had left them nearly nine months before they had seen evil times, indeed. What could a handful of men do against such a wilderness! Ragged, rheumatic, pallid men crowded around Iberville, tears from mingled joy and rage trickling through their shaggy, ove"), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.2.0"
    }
  }), _vm._v("rgrown beards.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.1.box.279.1409.1154.515.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.3.0"
    }
  }), _vm._v("Iberville was disappointed at what he saw, but he could not tell these men so. Not now. They demanded to be heard first. They ranted about the cold and miserably damp winter, of an isolation that was maddening, of the eternal watch against the Indians, of the desperate struggle just to keep warm and partly fed, of reptiles and insects that plagued them endlessly, of the despondency of embittered, homesick men looking out constantly toward the sea for a relief ship.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.2.box.275.1934.1156.331.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.4.0"
    }
  }), _vm._v("Their story was enough to make Iberville wonder if he had oversold the king on the practicability of immediate colonization; if Louisiana was yet an unconquerable waste; if the simultaneous struggles against the swampland, wild natives, and jealous rivals were too much for France to meet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.3.box.325.2284.1103.49.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.5.0"
    }
  }), _vm._v("But that night, under the warming influence of wine"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.0.box.281.411.1158.1156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("\nand cheerful comradeship, men again talked great schemes with the throb of ambition in their voices. Iberville was one who could inspire as well as comfort. A veteran of many campaigns in His Majesty's navy, he was an erect, impressive individual with a sensitive, wind-marked face, who knew both the culture of Paris and the savagery of the wild country. Men believed him instinctively. He told the assembly that he brought new hope and new blood. This colony would not die a-borning as some doubters were saying. This Louisiana, it would yet be conquered and made safe for France! It would become so strong that no army of Spaniards or Englishmen could ever take it! From the Gulf even to the mountains of Mexico they would spread the king's province and pour into the coffers of France quantities of gold such as the treasure-seeking Spaniards had never dreamed of. Furs and jewels the like of which the women of France had never seen before would be reaped from the country to the northward before the greedy English could get them.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.275.411.1164.1924.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.279.1589.1151.163.q.70"
    }
  }, [_vm._v("It was all brave whistling in the wilderness darkness. But this boundless expanse of land was a place to inspire unlimited ambitions in strong men.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.276.1763.1153.337.q.60"
    }
  }, [_vm._v("The tall, well-dressed St. Denis took both to wine and to talk slowly that evening. He listened and wondered. He was soon to meet many dreamers and men of action in this new world that was destined to go to the mightiest, and his own role was to be one of the most significant in determining who should control it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.3.box.275.2111.1152.224.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.3.0"
    }
  }), _vm._v("Late that night one of the stories took a serious turn. Jean Baptiste Le Moyne, Sieur de Bienville, the brother of Iberville, who had been in command of the fort, told of meeting an English ship in the Mississippi River com"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.282.415.1155.623.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("manded by a Captain Barr."), _c('sup', [_vm._v("1")]), _vm._v(" The captain, it was understood, was seeking to establish a \"republic.\" Bienville, who had an inferior command and realized that he could do nothing by force, had assumed a bold face and advised the English captain that he had made a mistake, that he was in a dependency of Canada and not in the Mississippi; besides, there was a large French colony located a short distance up the stream. The Mississippi, he explained, was farther on to the west. The duped English captain had then turned and sailed out of the Mississippi, heading westward.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.19.1.0.box.275.415.1162.1739.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.1.box.280.1059.1154.340.q.60"
    }
  }, [_vm._v("The men laughed loudly at the joke Bienville had played on the English captain, but there was grim warning in the incident, and they all knew it. In the small hours of the morning plans were laid for an expedition to the Mississippi to establish a fort. The English might be much stronger next time, and they might not be so easily fooled.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.2.box.277.1408.1157.571.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("There were good reasons for fearing England and hastening to forestall her without delay. With the end of King William's War in 1697 England had become free to colonize. A strong, ambitious rival with colonies so near gave stern warning to the French that their position was weak as well as precarious. Claims, discoveries, explorations, diplomacy, and tricky bluffs would not hold Louisiana against the land-hungry English or the gold-crazed Spaniards. Only possession would be adequate.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.3.box.275.1989.1154.165.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("And so, before the sun rose, the fort was bustling with new life. Preparation for the expedition to the Mississippi had begun.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.2.0.box.324.2223.1105.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.0.box.324.2223.1105.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.4.0"
    }
  }), _vm._v("Numerous scouting excursions for routes were made"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.259.411.1151.343.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("\nbefore the main expedition started. Iberville selected sixty men for the expedition, including his two brothers, Bienville and Antoine Chateauguay, and St. Denis. Bienville was dispatched by way of the lakes and Bayou Manchac to secure Bayogoula guides and men and then meet Iberville's party on the Mississippi.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.19.3.0.box.307.2297.551.32.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.19.3.0.box.307.2297.551.32.q.30"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v(" This name is sometimes given as Banks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.254.411.1156.1579.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "color": "rgb(0, 0, 0)",
      "clear": "both"
    },
    attrs: {
      "id": "para.20.1.1.box.256.767.1154.1106.q.60"
    }
  }, [_vm._v("On February 1 the main expedition embarked on a small transport"), _c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v(" 2")]), _vm._v(" \"loaded with everything required for a settlement.\" "), _c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v("3")]), _vm._v(" The chaplain of the expedition, Father Paul Du Ru, wrote a day-by-day diary, in which many vivid details of the historic journey have been preserved. \"On leaving the Bay,\" Father Du Ru wrote, \"we rowed in search of a breeze with the sloops towing us as much as they could. Finally we caught the breeze and we are moving by ourselves, but very slowly.\" Soon the breeze picked up, and the voyagers sailed westward along the coast into the spreading glow of a fiery sun that set in a cold sky beyond the mouth of the ever-important Mississippi. Darkness came on, and the chill winter evening invaded the ship's cabin, which was none too cheerful. The Jesuit missionary spoke of spiders and rats in the little cabin, which was only three feet high and about seven feet square. Five men were lodged in the cabin, but on a cold night the closeness was really an advantage.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.254.1885.1149.105.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _vm._v("On the second day they passed an island \"full of wildcats "), _c('sup', [_vm._v("4")]), _vm._v(" which the sailors of our transport hunt as game."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.275.413.1156.99.q.70"
    }
  }, [_vm._v("\nThe animals are killed with clubs. They are very fat but rather tasteless.\"")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.20.2.0.box.252.2048.1150.283.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.2.0.box.252.2048.1150.151.q.60"
    }
  }, [_c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v("2")]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _vm._v(" Iberville had been sick and may have been delayed behind a portion of the party which historians have called the expedition. It is reasonable to believe that St. Denis left with Iberville on February 1, but it is possible that he may have gone across land with Bienville.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.2.1.box.252.2215.1149.68.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.1.0"
    }
  }), _vm._v("3")]), _vm._v(" Quotations used in connection with this journey are those of Father Du Runless otherwise indicated.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.2.2.box.285.2300.271.31.q.70"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.2.0"
    }
  }), _vm._v("4")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("Possibly, raccoons.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.275.413.1160.1919.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.278.531.1154.394.q.60"
    }
  }, [_vm._v("At three o'clock on the morning of February 3, the party was aroused. The mouth of the Mississippi had been sighted. Blear-eyed men strained for a glimpse of it in the dim light. To Father Du Ru it looked dangerous and tricky, \"entirely fenced in with trunks of trees, petrified and hard as rock,\" a place where one careless turn of the rudder would have meant disaster.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.278.944.1155.448.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _vm._v("On the night of February 4, the camp of Bienville was sighted. Bienville came on board and announced that a location for a fort had been made. Later Bienville went ashore, taking with him some members of the party, including Father Du Ru. There in a bark-covered hut the men found an abundance of dried bear meat, venison, and an old Bayogoula Indian \"more dried up than the meat.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.278.1410.1157.748.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.3.0"
    }
  }), _vm._v("The site selected for the fort was thought to be one of the most attractive in the region. Most important of all, the Indians assured the French that the place was not flooded during high water. The point was eighteen leagues above the mouth of the river, on the east bank, at a point where the river narrowed. \"An edge of open forest, six hundred paces wide, extended along the river bank for about three leagues below them. Two leagues above was a forest of cypress . . . the very wood for pirogues. . . . Behind was an extended view of prairie land studded with clusters of trees.\" A group of workmen was set to work clearing the ground and making preparations for the erection of the fort.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.277.2167.1156.165.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.4.0"
    }
  }), _vm._v("But the laborers were slowed by a \"hundred showers.\" When the thunder raged the old Bayogoula Indian had his own explanation. It was Ouga, the Great Chief, he"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.1.0.box.289.411.1151.215.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _vm._v("\ntold Father Du Ru, \"who is firing cannon as we do.\" Apparently the Bayogoula had found some new expression for his religious beliefs after hearing French cannon fire.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.275.411.1165.1930.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.1.box.289.650.1150.343.q.70"
    }
  }, [_vm._v("The explorers found the climate of Louisiana most unpredictable. The wind changed to the south, bringing \"clouds of mosquitos\" and warmth for new violets. It was favorable weather for building. Hunters turned into carpenters and the party went without meat as a result, but the fort began to take shape.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.2.box.281.1005.1156.802.q.60"
    }
  }, [_vm._v("On February 15 Henry de Tonti floated into camp with a party of Canadian traders. There was great rejoicing at the arrival of this seasoned veteran of the wilderness. De Tonti was a colorful character, already a legend among woodsmen. He was known to the Indians as the \"Iron Hand,\" due to an iron hook which replaced a limb lost in battle and which, it is said, he wielded with special effect in hand-to-hand encounters with his foes. He had served in Canada and on the Gulf Coast as the lieutenant of another notable French explorer, Rene Robert Cavelier, Sieur de La Salle. Soldier, sailor, explorer, Indian conciliator, and fur trader, De Tonti was perhaps the best-informed man of his time on the mysteries of the western frontier.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.3.box.276.1826.1154.338.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _vm._v("That night the wind howled through the tall timber, and murky waves of the Mississippi slapped viciously at the river banks. Wet snow mixed with hail, and sleet beat down upon the men and smothered the fires. The men could not keep warm, but talk went on into the late hours of the night.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.4.box.275.2176.1151.165.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.4.0"
    }
  }), _vm._v("St. Denis, the tenderfoot, must have listened with amazement to the stories of De Tonti, tales of the great uncharted Mississippi Valley that stretched toward the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.275.416.1152.460.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _vm._v("\nCanadian homeland, stories of strange Indian tribes, trade routes, mines, fur traffic, death and starvation of men too weak or unlucky for the wilds. Who could know what secrets this far-flung valley held in its wooded and cane-covered retreats! Such meetings around flickering camp fires stimulated adventurous souls and set men to dreaming of new worlds to conquer, new fortunes to be grasped, new romantic lives to be lived.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.23.1.0.box.275.416.1155.1801.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.277.888.1153.748.q.60"
    }
  }, [_vm._v("St. Denis wondered why Louisiana should have waited nearly two centuries after discovery to be colonized, why it should be among the last strips of land on the continent to be possessed. Was it because of its mystical, treacherous-looking swamps, its tricky, half-hidden coast line, its entangling bayous and lakes that explorers and colonizers had turned back? Was the climate considered too unhealthy, the Indians too dangerous, the land too poor? Had France been too weak, too busy, or too interested elsewhere to seize this territorial prize? Men voiced apologies and speculations without conclusions, and then reaffirmed their faith in their own courage and in the power of France; England and Spain be damned!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.278.1647.1152.570.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.2.0"
    }
  }), _vm._v("To St. Denis this new land was a playground for brave and romantic hearts. Just what resolutions he may have made as the Frenchmen and Canadians sipped sparingly on their limited wine in the late hours of that stormy night cannot be known. But the dark magic of the wilderness had possessed him. Explorers, colonizers, politicians, men of fortune were to come and go, but St. Denis had planted his feet and soul firmly upon the rich black soil of Louisiana. Except for brief periods he was never to leave it again.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.2.0.box.280.2286.1149.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.0.box.280.2286.1149.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.3.0"
    }
  }), _vm._v("When the wind became favorable for ascending the river, St. Denis was sent with a sloop to prepare the way"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.281.412.1151.863.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("\nfor a visit to the Bayogoula tribe. This was an important mission, for it was essential to the security of the fort to have friendly natives for neighbors, who would serve as a buffer against the English and the hostile savages. From the very beginning of his life in Louisiana St. Denis was the chief \"advance man\" or scout. Strange, that almost at once he should become the chief diplomat, conciliator, bargainer, and suave contact man in general, but such was his role. His influence was almost uncanny from the very beginning. He had an instinctive understanding of the Indians, such perhaps as no other man in the Southwest ever possessed. He early realized that the man who controlled the Indians would control the wilderness. And in this realization lay his greatest power and success and claim to fame.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.275.412.1157.1985.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.279.1297.1151.577.q.60"
    }
  }, [_vm._v("In spite of stormy weather the main party sailed up toward the village of the Bayogoulas. Rain slashed down like perpendicular rivers; the wind whipped the fires so furiously that it was impossible to cook enough food. The men ate half-cooked sagamite dipped from simmering kettles with spoons of biscuits. The river was rising, and the treacherous currents and floating deadwood made small-boat traveling hazardous. One of the Canadians injured his arm in an accident, and it had to be amputated with a saw made out of a big knife.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.275.1886.1152.511.q.60"
    }
  }, [_vm._v("But at times the sun would break through the low rain clouds and penetrate the swampy mist. Then it would be noted that \"there was always a fine hedge of green cane and occasionally willows standing out\" along the river's edge, against a background of more cane and tall trees that struggled to rise above the swamps. Myriads of wild ducks and other fowls rose from the water's edge, their wet wings flinging sparkling sprays into the sunlight. There were parakeets \"by the thousands,\" birds"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.283.413.1152.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("\nof strange noises and grotesquely gorgeous hues. They enlivened the drab, rain-drenched forest.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.276.413.1159.1909.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.281.532.1154.225.q.60"
    }
  }, [_vm._v("As Iberville and his men approached the village of the Bayogoulas, French beards were trimmed and fresh linen put on. It was understood that St. Denis would have the population prepared for the dignity of the occasion.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.281.767.1154.342.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.2.0"
    }
  }), _vm._v("The landing place was lined with the natives. A bizarre welcome to the French it was; for the Indians were decked in their best feathers and beads and were singing the calumet, their song of peace, at the top of their voices. In the lead canoe, especially decorated with bright flags, came Bienville, who had gone ahead with St. Denis.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.282.1119.1150.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.3.0"
    }
  }), _vm._v("It was an impressive and successful meeting. St. Denis, the master of ceremonies, had arranged matters well. There was something of the stage director in St. Denis. He became famous for such Indian maneuvers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.4.box.280.1350.1154.456.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.4.0"
    }
  }), _vm._v("Like other natives of this section, the Bayogoulas were a religious folk, worshiping their own favorite gods. Even those too poor to own their homes contributed to the building of temples. Their temples were built of thatch and covered with cane. Inside burned the lamps of eternal fire, among many rows of packages piled one on the other. These were the bones of the dead chiefs carefully wrapped in palm mats.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.5.box.276.1816.1155.506.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.5.0"
    }
  }), _vm._v("Entertainment of the best quality was in order for the guests. Father Du Ru, impressed by the Bayogoulas, gave considerable space in his diary to their customs: \"In the evening there were ball games. The men play in pairs; one of them has a ball in his hand and throws it ahead. Both of them run as fast as they can, throwing a big stick at the ball, and as well as I could make out, the one whose stick is closest to the ball wins the play. Then the one who wins throws the ball the next time. This is"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.287.411.1154.758.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _vm._v("\na rather strenuous game; nevertheless, it is played by both the old and young. The women have a game also. They separate into two parties between the large posts in the square. Somebody throws a little ball in the center, and the one who seizes it first tries her best to run around the post on her side three times, but she is prevented by the women of the opposite party, who seize her if they can. When she can no longer resist them, she throws the ball to her people, who make a similar effort to run around the post. Sometimes the ball falls into the hands of the other side, which then tries the same maneuver. The games are very long and ordinarily when they are over the women plunge into the water to refresh themselves.\"")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.275.411.1166.1927.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.275.1181.1163.1157.q.60"
    }
  }, [_vm._v("After the games, dances were begun. \"The singers appeared first and went to sit on the mat in the midst of the square. The leader of the band beat the measure on a small drum of deer skin. . . . The men wear skins and red linen cloth. The women have on the dresses of bark . . . with a fringe about their waists of the same material, [falling] down like the nets which one puts on our horses in summer to protect them from flies. The nets reach down to the knees and cover them effectively. Each man carries something in his right hand: a hatchet, an umbrella, a knife, . . . and the women have in both hands large bunches of fine white feathers. The singers have very soft voices and the dancers very beautiful cadence. The women are of a surprising modesty. They dance opposite their men, their bodies a little bent, their eyes cast down, . . . marking the cadence admirably well with their bunches of feathers, so that it is only their hands that move. Flutes and drums set the measure. These are played by handsome young people with their legs decorated with small gourds filled with stones with"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.278.413.1152.168.q.60"
    }
  }, [_vm._v("\nwhich they make the cadence. There is one thing prettier than anything else I ever saw before; this is the bizarre color with which they paint their faces.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.27.1.0.box.277.413.1154.872.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.277.590.1150.108.q.70"
    }
  }, [_vm._v("After the dance came the banquet royal. All the delicacies of the tribe were spread in abundance.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.278.708.1153.517.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.2.0"
    }
  }), _vm._v("At last the great exhausting day of festivities drew to an end. It had been an elaborate reception abounding in good manners, entertainment, and food. But the Bayogoulas knew no limit to hospitality. The French were asked if all had eaten enough, and if a woman was wanted for each man. It is recorded that Iberville answered by showing them his hand, saying that the skin of the Frenchman was white and should not be blended with that of the Indian, which was red and swarthy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.3.box.329.1236.1100.49.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.3.0"
    }
  }), _vm._v("Colonial alliances, it appeared, were off to a good start.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.2.0.box.275.1349.1155.982.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.0.box.277.1349.1153.397.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.4.0"
    }
  }), _vm._v("But alarm as well as gaiety was in store for the French at the Bayogoula village. They were told that the English were arming the Chickasaw. That could be for no other purpose than setting this powerful tribe on the French. This reminded them anew that all the arts of diplomacy, duplicity, and battle common to the winning of empires could be expected in this territorial contest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.1.box.275.1756.1155.575.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.5.0"
    }
  }), _vm._v("It was Iberville's first plan, upon hearing of the English design, to instruct De Tonti, on his return to Illinois, to entrap the English leaders into coming among the Tonikan Indians of Louisiana by promising profitable trading, and then to arrest the English and hand them over to a detail of French Canadians. However, it was learned that the English were too numerous for this stratagem to prove successful. The best that could be done at the time, then, was to try to unite all the Indians south of the Chickasaw in a pro-French confederacy, and possibly to arm them.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.275.411.1157.1924.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.0.box.280.411.1152.642.q.70"
    }
  }, [_vm._v("There were obstacles to this plan at the beginning. Bad medicine was brewing between the Bayogoulas and the neighboring Houmas. However, obstacles or no obstacles, it was expedient that an Indian alliance be accomplished if possible. The first step in such a plan was to settle local controversies, to make allies out of neighboring enemies. The nearness of the two tribes to the proposed French fort made it exigent to bring the Indians to terms. For if the Bayogoulas lived near the French as allies, the Houmas would regard both French and Bayogoulas as enemies unless an understanding was reached.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.280.1063.1151.225.q.60"
    }
  }, [_vm._v("Again St. Denis was sent ahead to begin the twofold diplomatic work of starting a friendship between the French and the Houmas and suggesting that they come to terms with their enemy, the Bayogoulas.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.2.box.280.1298.1151.344.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  }), _vm._v("On March 5 the main party reached the village of the Houmas. The travelers found evil times upon the tribe. Attacks by the Bayogoulas and an epidemic of the flux had laid them low. But they rose up as best they could to meet the occasion, and a few lean warriors stood at the landing bravely singing the calumet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.3.box.278.1651.1151.278.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.3.0"
    }
  }), _vm._v("Whether because of the devastating raids of the Bayogoulas, the weakening effects of the flux, or the diplomacy of St. Denis, a treaty was arranged between the two tribes without delay. It was a victory for the plagued, bedridden Houmas as well as for the French.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.4.box.275.1946.1153.279.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.4.0"
    }
  }), _vm._v("However, for a time, this important diplomatic victory hung by a delicate thread. In this nation the white men learned the vital lesson that winning friendship and keeping it are two very different things, that Indian diplomacy was not so simple as they would like to believe.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.5.box.276.2235.1150.100.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.5.0"
    }
  }), _vm._v("Iberville, in the course of the final negotiation, committed a most offensive blunder. The Houmas demanded"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.0.box.282.412.1157.698.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("\nthat the Bayogoulas come to them to smoke the pipe of peace, bringing presents to ransom the Bayogoula prisoners according to the customs of the day. This was done as ordered. It was observed that the Indians conducted intertribal relations with dignity and honor and according to a form of \"international\" law. Thus far, all had been well. But Iberville was either too cautious or too skeptical, or as the Indians might have explained it, \"too European.\" He arranged an escort for the Bayogoulas on the return trip, just to be sure that they would arrive with their scalps intact, and that the work of peacemaking would not have to be done all over again.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.275.412.1164.1863.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.281.1121.1155.279.q.70"
    }
  }, [_vm._v("The Houmas were greatly offended; they let the white men know that they considered their honor doubted and insisted that in the future reliance should be placed upon their word. It was a tense moment that the French did not forget.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.275.1411.1161.864.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.2.0"
    }
  }), _vm._v("While the diplomatic tribunal was in session, Father Du Ru had time to look about the Houmas' village. He found it in a miserable condition. Great numbers had recently died, and the village was in full mourning. \"The women bewail their dead day and night.\" The Great Chief had been among the victims and had been lying in state for over two months. As soon as all the flesh had dropped from his bones, they would be removed to the temple and there stored with his former possessions. The widows of the Great Chief spent some of their time spinning bark and weaving at the looms, but most of their days were occupied in mourning. Among other ceremonies, they drank ritualistically in honor of their dead. They would swallow as much as three or four pots of water and then strain horribly to spew it up. When it was not"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.284.413.1153.287.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _vm._v("\nfound easy to emit the liquid, they put herbs in the water to provoke vomiting. In spite of their gruesome rituals, however, the observing chaplain found them a people not without enchantment. \"The women charm us by their modesty. . . . They speak softly.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.275.413.1162.1871.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.281.710.1155.817.q.60"
    }
  }, [_vm._v("It was Iberville's intention to secure guides from the Houmas and journey up the Red River to the Caddodaquois nation as soon as possible. For it was reported that Spaniards from Mexico had pushed eastward as far as that river, and the proposed alliance should be arranged as rapidly as possible. But a disappointment was in store for the Frenchmen. The Indians told them that up the river a great log raft had been formed by a mass of tangled logs, which clogged the Red River from bank to bank for miles and made passage by boat impossible. The only other way they knew to reach the Caddodaquois was to ascend the Mississippi to the village of the \"Big\" Tensas, and from there proceed overland to the west, beyond the village of the Natchez Indians.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.2.box.280.1537.1153.167.q.60"
    }
  }, [_vm._v("The expedition set out. Pulling against the gray swirling current of the swollen river was a strenuous task, but by March 12 the French reached the Natchez nation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.3.box.276.1713.1157.396.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.3.0"
    }
  }), _vm._v("The approach to the Natchez villages was an inspiring sight. Situated upon a high, picturesque bluff, beautifully landscaped with magnificent trees, the place looked like a strange fairyland. The peach and plum trees were in bloom, and in the March wind the waving patches of white and pink gave animation and delicate color to the landscape.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.4.box.275.2119.1154.165.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.4.0"
    }
  }), _vm._v("The French were met by the brother of the chief. He was an impressive man of fine build, with a long face, sharp eyes, an imperious aquiline nose, a chestnut com"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.0.box.279.414.1155.158.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _vm._v("plexion, and the \"air of an ancient emperor.\" He brought the regrets of his brother, who, at the time, was another hard-hit victim of the flux.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.275.414.1160.1860.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.280.591.1155.520.q.60"
    }
  }, [_vm._v("The officials, in time, were presented to the chief, who received them with dignity lying on a cot in his home. His domicile was different from those of the lesser chiefs; only he and his women slept in it. There was one bed in it, an especially elaborate piece of furniture colorfully decorated. It was explained that this was the bed used for death only and that the chief was expected to use it soon. In spite of his critical condition gifts were exchanged and friendship acknowledged.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.279.1121.1155.329.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.2.0"
    }
  }), _vm._v("The Natchez were found to possess a superior culture and highly developed social, religious, and political systems. They were a fine-looking people. The women were known for their grace and beauty. They dressed in white linen robes which extended from their shoulders to their ankles.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.275.1470.1159.737.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.3.0"
    }
  }), _vm._v("The dress of the girls was different from that of the women, \"for they are clad only in a species of skirt, fastened around the waist. . . . The skirts of the girls are sewed with fine white thread and only cover their nakedness from the waist down to the knees. They are fastened with two strings, with tassels at the end of each. The front is ornamented with fringe. The garment is worn by the girls until the period of nubility, when they assume a woman's garment. They are very courteous and obliging, and fond of the French. . . . [The women's] heads are enveloped in long, black hair, which falls gracefully around their waists, and in many instances to their ankles.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.4.box.327.2226.1103.48.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.4.0"
    }
  }), _vm._v("St. Denis was a favorite among the Natchez. His"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.0.box.290.411.1152.345.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _vm._v("\nstately bearing and graceful manners impressed the Indians. He possessed the knack of anticipating their thoughts, and his understanding of their nature and customs was soon to become legendary. St. Denis, in turn, was charmed by this gentle race, who lived life simply and beautifully in their picturesque fairyland.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.32.1.0.box.286.411.1156.1052.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.286.767.1155.696.q.60"
    }
  }, [_vm._v("If there had been a prophet to foretell the future, this meeting of the French and the Natchez would have been grim instead of gay. For this was the first act in an ironic drama. This same winsome St. Denis, who charmed and was charmed by this noble race, was the man who one day would blot their ancient culture from the face of the earth. That the Natchez nation was a military power strong enough to threaten the existence of a European colony was a fact that dawned only later upon the French colonizers. Strange dramas were in the making during the gambles of these formative years when the seed of the Louisiana colony was sprouting.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.2.0.box.275.1534.1161.745.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.2.0.box.275.1534.1161.745.q.60"
    }
  }, [_vm._v("From the Natchez the French journeyed up the river about thirty-five miles to the Tensas tribe. On the second day there they witnessed a frightful spectacle. During an electrical storm, lightning struck the local temple. In mad confusion the Indians assembled around the flaming structure \"howling like devils possessed,\" tearing out their hair, elevating their hands to heaven and invoking their Great Spirit to come down and extinguish the flames. They took up mud and besmeared their faces. When these ceremonies did not bring an end to the fire, the fathers and mothers brought out their children and, after strangling them, tossed them into the flame. On orders from Iberville to stop this mass murder, the French"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.283.412.1156.166.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("\nseized the infants by force, but not before over two hundred had been prepared for the sacrifice and seventeen had perished.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.275.412.1164.1920.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.283.590.1156.219.q.60"
    }
  }, [_vm._v("While at this village Iberville developed some trouble with his knee and was unable to walk. He was forced to give up the prospective Red River expedition. It was left to St. Denis and Bienville.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.284.828.1154.224.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.2.0"
    }
  }), _vm._v("On March 22, St. Denis and Bienville set out with twenty-one Canadians, six Tensas and one Ouachita for the Red River country and the nation of the Caddodaquois.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.279.1063.1159.513.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.3.0"
    }
  }), _vm._v("Only hardy, brave men would have attempted such a journey at that season, but it was considered extremely urgent. Though no established boundaries for Louisiana existed, the French spoke of the alleged activities of the Spaniards in the Red River section as \"encroachments\" and a threat. With the Spaniards established so near, both on the east in Florida and on the west in Mexico, and with the English bearing down from the north, this was neither the time nor the place for fair-weather explorers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.279.1587.1157.270.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.4.0"
    }
  }), _vm._v("The country had been overflowed; trails, where there were any, had been washed or covered from sight; slashing rains soaked everything. The entire first day was spent marching in a country which was knee-deep in water.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.5.box.277.1876.1156.339.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.5.0"
    }
  }), _vm._v("On the morning of the twenty-third the party crossed a river in a pirogue which they had been able, with rare good fortune, to borrow from some Indians. More often the men swam or waded the streams, pushing their baggage before them on improvised rafts, and firing their guns to frighten the alligators away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.6.box.275.2224.1156.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.6.0"
    }
  }), _vm._v("After two days the Te"), _c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _vm._v("nsas deserted. They did not like walking n"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("aked through cold water. Bienville himself"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.1.0.box.280.413.1156.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\nlamented upon the disadvantages of wading for a man of medium height in such circumstances, and he envied the tall St. Denis.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.0.0.box.276.346.1182.1976.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.275.413.1161.1928.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.279.592.1155.225.q.60"
    }
  }, [_vm._v("On the twenty-seventh two men came down with the flux, but the expedition had to proceed. A comrade was left to care for them, and the explorers plunged on farther into the boggy forest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.277.828.1157.741.q.60"
    }
  }, [_vm._v("Next day they arrived at a small village of the Ouachitas, where they secured a \"Nachito\" to guide them to the Natchitoches village. Three days later they camped on the soggy edge of a marsh. Provisions were low, and three men had been walking with a burning fever for two days. But the following day the full crew was wading in water up to the armpits while torrents of rain beat down upon them. No game had been found, and rations were now reduced to two small sagamités a day. That night they could find no large trees to strip for bark for temporary cabins, so the men curled themselves upon the sodden ground and slept with the rain washing over their exhausted bodies.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.3.box.275.1590.1158.341.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _vm._v("The rain was still gushing down next morning. They came to a canebrake and had to fight the sharp wet blades from their faces. The entire day of May 5 was spent crossing a swamp. During the day seven men were seized with chills and were obliged to climb up into the trees and remain there until they recovered.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.4.box.275.1943.1155.270.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.4.0"
    }
  }), _vm._v("Bienville wrote in his journal: \"This is good work for tempering the fires of youth. . . . We never stop singing and laughing, to show our guides that fatigue does not trouble us, and that we are different men from the Spaniards.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.5.box.275.2233.1153.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.5.0"
    }
  }), _vm._v("On the sixth, near the Red River, they came to the Natchitoches nation. The peace pipe was smoked, and"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.260.411.1151.403.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\npresents were exchanged. Upon the success of such small tribunal meetings in the flooded wilderness depended the permanency of Louisiana and the French colonial empire. Here, along the Red River, was an enchanting bit of country populated by an amiable, industrious people who would become important in the life of St. Denis and the colony.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.248.411.1163.1922.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.257.825.1152.578.q.60"
    }
  }, [_vm._v("The party, after securing a guide from the Natchitoches chief, headed out over a tedious country of bogs, swamps, and a network of log-jammed streams. They passed through the village of the Nakasas on the bank of the Red River, and on the twentieth arrived at the Yataches. It had been expected that the long-sought Caddodaquois would be found only a two-day journey from here, but due to the strong current of the river the French were told that ten days and nights would be required.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.251.1414.1156.747.q.60"
    }
  }, [_vm._v("There were some Caddodaquois visiting at the village, and they told the French of a Spanish settlement five and a half leagues to the west of their village, \"where there are white, black, and mulatto men, women, and children engaged in cultivating the land.\" The Indians said that the Spaniards often came to the Caddodaquois on horseback to the number of thirty or forty, but they never slept there. Asked if the Spaniards had mines, they replied that the white men raised corn and had money like the pieces the Frenchmen showed them and that they staked it on cards, some of them stamping their feet and tearing the cards to pieces when they lost. They could not speak definitely about the mines.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.3.box.248.2172.1151.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.3.0"
    }
  }), _vm._v("So much time had been lost because of the flooded country, and the time designated to meet Iberville was so near, that the French decided to return without fur"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.275.415.1154.282.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("ther investigation. On the return trip they discovered that war had broken out among their neighboring allies. The Bayogoulas had gone on the warpath and massacred their neighbors, the Mongoulachas, and filled their empty cabins with an importation of Colapissas and Sioux.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.275.415.1154.457.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.277.709.1152.163.q.60"
    }
  }, [_vm._v("When the party at last reached Biloxi they reported, \"The rumors are true!\" The Spaniards were very near on the west, almost to the Red River.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0e18892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 60
// module chunks = 0